<template>
  <div id="page-container" :class="classContainer">
    <!-- <button @click="setAttendance" style="margin-top: 90px">setAttendanceModal</button> -->
    <!-- <button @click="getWeekEvent">getWeekEvent</button>
    <div>dropEvent: {{ dropEvent }}</div>
    <div>attendanceEvent: {{ attendanceEvent }}</div> -->
    <!-- <template v-if="isTodayAttendance"> -->
    <attendance-alert :cnt_attendance="cnt_attendance"></attendance-alert>

    <landing-event-modal></landing-event-modal>

    <event-modal :usrAttend="cnt_attendance" />
    <!-- </template> -->
    <!-- Page Loader -->
    <div id="page-loader" :class="{ show: $store.state.settings.pageLoader }"></div>
    <!-- END Page Loader -->

    <!-- Page Overlay -->
    <div
      id="page-overlay"
      v-if="$store.state.layout.sideOverlay && $store.state.settings.pageOverlay"
      @click="() => $store.commit('sideOverlay', { mode: 'close' })"
    ></div>
    <!-- END Page Overlay -->

    <!-- Side Overlay -->
    <base-side-overlay v-if="$store.state.layout.sideOverlay" :class="layoutClasses.sideOverlay">
      <slot name="side-overlay"></slot>
    </base-side-overlay>
    <!-- END Side Overlay -->

    <!-- Sidebar -->
    <base-sidebar v-if="$store.state.layout.sidebar" :class="layoutClasses.sidebar">
      <slot name="sidebar"></slot>
    </base-sidebar>
    <!-- END Sidebar -->

    <!-- Header -->
    <base-header v-if="$store.state.layout.header" :class="layoutClasses.header">
      <!-- :style="{ zIndex: mobilePageTitle ? '12' : '10' }" -->
      <slot name="header"></slot>
    </base-header>
    <!-- <OMC></OMC> -->
    <!-- END Header -->

    <!-- Main Container -->
    <div id="main-container">
      <slot name="content"></slot>
      <!-- <transition :name="isMobile ? '' : 'fade'" :mode="isMobile ? '' : 'out-in'"> -->
      <router-view></router-view>
      <!-- </transition> -->
    </div>
    <!-- END Main Container -->

    <!-- Footer -->
    <!-- <mounting-portal mountTo="body" name="source" append> -->
    <base-footer v-if="$store.state.layout.footer" :class="layoutClasses.footer">
      <slot name="footer"></slot>
    </base-footer>
    <!-- </mounting-portal> -->

    <!-- END Footer -->
    <Spinner :loading="loadingStatus" :loading_content="loadingContent" />
  </div>
</template>

<style lang="scss">
// Custom router view transition
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<script>
// Import main layout components
import BaseHeader from '@/layouts/partials/Header';
import BaseSidebar from '@/layouts/partials/Sidebar';
import BaseSideOverlay from '@/layouts/partials/SideOverlay';
import BaseFooter from '@/layouts/partials/Footer';
import EventModal from '@/views/Events/OMZAttendanceModal';

import { mapState, mapActions } from 'vuex';
import Spinner from '@/components/Spinner';

export default {
  name: 'BaseLayout',
  components: {
    BaseHeader,
    BaseSidebar,
    BaseSideOverlay,
    BaseFooter,
    Spinner,
    EventModal,
    // OMC,
  },
  props: {
    layoutClasses: Object,
  },
  computed: {
    classContainer() {
      return {
        'sidebar-r': this.$store.state.layout.sidebar && !this.$store.state.settings.sidebarLeft,
        'sidebar-mini': this.$store.state.layout.sidebar && this.$store.state.settings.sidebarMini,
        'sidebar-o': this.$store.state.layout.sidebar && this.$store.state.settings.sidebarVisibleDesktop,
        'sidebar-o-xs': this.$store.state.layout.sidebar && this.$store.state.settings.sidebarVisibleMobile,
        'sidebar-dark': this.$store.state.layout.sidebar && this.$store.state.settings.sidebarDark,
        'side-overlay-o': this.$store.state.layout.sideOverlay && this.$store.state.settings.sideOverlayVisible,
        'side-overlay-hover': this.$store.state.layout.sideOverlay && this.$store.state.settings.sideOverlayHoverable,
        'enable-page-overlay': this.$store.state.layout.sideOverlay && this.$store.state.settings.pageOverlay,
        'page-header-fixed': this.$store.state.layout.header && this.$store.state.settings.headerFixed,
        'page-header-dark': this.$store.state.layout.header && this.$store.state.settings.headerDark,
        'main-content-boxed': this.$store.state.settings.mainContent === 'boxed',
        'main-content-narrow': this.$store.state.settings.mainContent === 'narrow',
        'rtl-support': this.$store.state.settings.rtlSupport,
        'side-trans-enabled': this.$store.state.settings.sideTransitions,
        'side-scroll': true,
        heightFitContent: this.heightFitContent,
      };
    },
    ...mapState([
      'userId',
      'loadingStatus',
      'loadingContent',
      'isTodayAttendance',
      'isLandingEventModal',
      'isLandingEvent',
      'isEventAttendance',
      'cnt_attendance',
      'totalTokenZIndex',
      'heightFitContent',
      'mobilePageTitle',
      'isMobile',

      'dropEvent',
      'attendanceEvent',
    ]),
  },
  async created() {
    this.$store.commit('setColorTheme', { theme: this.$store.getters.appColorTheme });
    await this.getWeekEvent();

    return;
  },
  mounted() {
    this.setAttendance();
  },
  methods: {
    ...mapActions(['getWeekEvent']),
    setAttendance() {
      if (this.$route.path.includes('/landing')) {
        return;
      }

      if (this.isLandingEvent && this.isLandingEventModal) {
        this.$bvModal.show('modal-landing');
      }

      if (this.isTodayAttendance) {
        this.$bvModal.show('modal-attendance');
      }
    },
  },
  watch: {
    isTodayAttendance() {
      this.setAttendance();
    },
  },
};
</script>
